import { render } from "./NewButton.vue?vue&type=template&id=9526a1a6"
import script from "./NewButton.vue?vue&type=script&lang=js"
export * from "./NewButton.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__